import { onMounted, nextTick, ref, onUnmounted, computed, watch, reactive, toRefs } from 'vue'
import useStatistics from '@composables/statistics/use-statistics.js'
import useNumbers from '@composables/use-numbers'
import Chart from 'apexcharts'

export default function useChart(params) {
  const { displayAmount } = useNumbers()

  const options = computed(() => ({
    year: params?.year || null,
    month: params?.month || null,
    from: params?.from || null,
    to: params?.to || null,
  }))

  const chartContainer = ref(null)
  const stats = useStatistics(options.value)

  const state = reactive({
    data: computed(() => params?.dataByMonth || []),
    period: stats.period,
    chart: null,
    chartOptions: computed(() => {
      return {
        chart: {
          type: 'line',
          width: chartContainer.value?.offsetWidth - 2,
          height: chartContainer.value?.offsetHeight - 2,
          redrawOnParentResize: false,
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          },
          sparkline: {
            enabled: true
          }
        },
        colors: ['#6fbbff'],
        dataLabels: {
          enabled: false
        },
        series: [
          {
            data: state.data
          }
        ],
        stroke: {
          curve: 'smooth',
          width: 1
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        xaxis: {
          labels: {
            show: false
          }
        },
        legend: {
          show: false
        },
        tooltip: {
          // enabled: false,
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return `
                <div class="stat-detail">
                  <p>
                    <b>
                      <small>
                        ${displayAmount(series[seriesIndex][dataPointIndex])} €
                      </small>
                    </b>
                    <small>
                      (${state.period?.months[dataPointIndex] || ''})
                    </small>
                  </p>
                </div>
              `
          }
        }
      }
    }),
  })
  
  onMounted(() => {
    nextTick(() => {
      if (chartContainer.value) {
        state.chart = new Chart(chartContainer.value, state.chartOptions)

        state.chart.render()
      }
    })
  })

  onUnmounted(() => {
    state.chart && state.chart.destroy()
  })

  watch(
    () => state.chartOptions,
    () => {
      state.chart && state.chart.updateOptions(state.chartOptions)
    }
  )

  return {
    ...toRefs(state),
    chartContainer,
  }
}

